module.exports = __webpack_public_path__ + "img/3d.f3ecb9c7.png";